/* eslint-disable camelcase */
import MessageService from 'message-service/message-service';
import DataEvents from '@gameday/core/events/DataEvents';
import TrackingEvents from './enums/events';

const { GAME_SWITCH_COMPLETE } = DataEvents;

let siteName;
let trackingConf;
let currentGameData;
let firstload;
let appName;

const {
    GD5_APP_ASYNC_TRACKING,
    GD5_APP_PAGELOAD_TRACKING
} = TrackingEvents;

const track = (cfg) => {
    if (!siteName) {
        siteName = (trackingConf?.props && trackingConf?.props?.siteName) ? trackingConf.props.siteName : 'Major League Baseball';
    }

    if (!appName) {
        appName = trackingConf?.tracking?.props?.appName || 'Gameday';
    }

    const {
        componentName = [],
        componentText,
        selectedIndex,
        activity = '',
        dynamic_component = appName,
        atBatClickplayIndex,
        mediaProps,
        playerContext,
        events,
        gamedayMini,
        linkName,
        dfvReplay
    } = cfg || {};

    const params = {
        dynamic_component, // prop12
        dynamic_componentAction: appName + ': ' + componentName?.join(': ') + (activity ? `: ${activity}` : ''), // prop14
        isDynamic: true,
        gameData: currentGameData,
        playIndex: cfg?.playIndex,
        componentName: (componentName && componentName?.length > 0) ? componentName[0] : '',
        componentText,
        atBatClickplayIndex,
        playerContext,
        events,
        linkName,
        dfvReplay
    };

    if (typeof selectedIndex !== 'undefined') {
        params.selectedIndex = selectedIndex + '';
    }

    if (typeof atBatClickplayIndex !== 'undefined') {
        params.dynamic_componentAction = 'Major League Baseball: ' + appName + ':' + (activity ? ` ${activity}` : '');
    }

    if (typeof mediaProps !== 'undefined') {
        params.async_media = mediaProps;
    }

    if (gamedayMini) {
        params.gamedayMini = true;
    }

    if (linkName) {
        params.linkName = linkName;
    }

    return MessageService.publish(GD5_APP_ASYNC_TRACKING, params);
};

const trackPage = (cfg) => {
    const { playIndex, fieldvision = false, dfv = false, gamedayMini = false } = cfg || {};

    const params = {
        gameData: currentGameData
    };

    if (playIndex) {
        params.playIndex = playIndex;
    }

    if (fieldvision) {
        params.fieldvision = true;
    }
    if (dfv) {
        params.dfv = true;
    }
    if (gamedayMini) {
        params.gamedayMini = true;
    }

    return MessageService.publish(GD5_APP_PAGELOAD_TRACKING, params);
};

export default {
    init: function () {
        if (!firstload) {
            MessageService.one.call(this, GAME_SWITCH_COMPLETE, trackPage);
            firstload = true;
        }
    },

    setProps: function (conf) {
        if (!this.trackingConf) {
            this.trackingConf = conf;
            trackingConf = conf;
        }
    },

    setData: function (data) {
        currentGameData = data;
        this.currentGameData = data;
    },

    getData: function (data) {
        return this.currentGameData;
    },

    track: function (opts) {
        return track(opts);
    },

    /* first page load */
    track_pageload: function (playerIndex) {
        trackPage();
    },

    /* AtBat Detail view page load */
    track_atbat_detail_pageload: function (playerIndex) {
        trackPage(playerIndex);
    },

    /* Gameday 3D view page load */
    track_fieldvision_pageload: function () {
        trackPage({
            fieldvision: true
        });
    },

    /* atbat overlay click */
    track_atbat_overlay_launch: function (cfg) {
        return track({ ...cfg });
    },

    /* dfv_replay_overlay_launch */
    track_dfv_replay_overlay_launch: function (cfg) {
        const { atBatIndex, playStartTime } = cfg;
        if (typeof atBatIndex !== 'undefined' && typeof playStartTime !== 'undefined') {
            return track({ ...cfg, dfvReplay: true });
        }
    },

    track_new_batter_event: function () {
        return track({
            componentName: ['New Batter'],
            activity: 'New Batter'
        });
    },

    /* DFV Load */
    track_dfv_pageload: function () {
        trackPage({
            dfv: true
        });
    },

    /* GD Mini Load */
    track_gamedayMini_pageload: function () {
        trackPage({
            gamedayMini: true
        });
    },

    track_click: function (cfg) {
        const {
            componentName,
            selectedIndex,
            text,
            activity,
            linkName,
            gamedayMini,
            dynamic_component
        } = cfg;
        return track({
            componentName,
            selectedIndex,
            componentText: text?.replaceAll('_', ' '),
            activity,
            linkName,
            gamedayMini,
            dynamic_component
        });
    }

};
